export default __webpack_public_path__ + "7ecd5da36b6374d8ba5013b29e72bbdd.png";